import { PROJECT } from '../../helper/util';

export enum LAYOUT_ENUM {
	STANDARD = 'standard',
	ADVANCED = 'pro',
	FULLSCREEN = 'fullscreen',
}

export const SETTING_ENUM = new Map([
	[
		'THEME',
		{
			title: 'trade-navigator.theme',
			name: 'theme',
			options: [{ value: 'dark' }, { value: 'light' }],
		},
	],
	[
		'WATER_MARK',
		{
			title: 'trade-navigator.water_mark',
			name: 'waterMark',
			options: [{ value: true }, { value: false }],
		},
	],
	[
		'LAYOUT_MASTER',
		{
			title: 'trade-navigator.layout',
			name: 'layout',
			options: [
				{ value: LAYOUT_ENUM.STANDARD, label: 'trade-navigator.layout_standard' },
				{ value: LAYOUT_ENUM.ADVANCED, label: 'trade-navigator.layout_advanced' },
			],
		},
	],
	[
		'LAYOUT_CONTRACT',
		{
			title: 'trade-navigator.layout',
			name: 'layout',
			options: [
				{ value: LAYOUT_ENUM.ADVANCED, label: 'trade-navigator.layout_advanced' },
				{ value: LAYOUT_ENUM.FULLSCREEN, label: 'trade-navigator.layout_full_screen' },
			],
		},
	],
  [
    'ORDER_CONFIRM',
    {
      title: 'preference.order_confirmation',
      name: 'orderConfirm',
    }
  ],
]);

/**
 * 设置面板配置
 */
export const SETTING_CONFIG = new Map([
	[PROJECT.MASTER, [
    SETTING_ENUM.get('THEME'),
    // SETTING_ENUM.get('WATER_MARK'),
    SETTING_ENUM.get('LAYOUT_MASTER'),
  ]],
	[PROJECT.CONTRACT, [
    SETTING_ENUM.get('THEME'),
    // SETTING_ENUM.get('WATER_MARK'),
    SETTING_ENUM.get('LAYOUT_CONTRACT'),
    SETTING_ENUM.get('ORDER_CONFIRM'),
  ]],
]);
